import React, { useEffect, useState } from 'react';
import { Grid, Skeleton, Alert, Link } from '@mui/material';
import Chart from 'react-apexcharts';
import axios from 'src/utils/axios';
import { useTheme } from '@mui/material/styles';

const ServiceComplaint = ({ ServiceShopId, EmployeeRole }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    axios.get(`GetServiceComplaint/${ServiceShopId}`).then((response) => {
      if (response) {
        setData(response.data);
      }
      setLoading(false);
    });
  }, [ServiceShopId]);

  const ServiceComplaintData = {
    series: [
      {
        name: 'Şikayetler',
        type: 'column',
        data: data.map((item) => item.Complaint)
      },
      {
        name: 'Mamul Adedi',
        type: 'line',
        data: data.map((item) => item.Mamul)
      }
    ],
    options: {
      chart: {
        type: 'line',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          }
        }
      },
      title: {
        text: 'Toplam Şikayet ve Mamul Adedi'
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [0],
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          if (seriesIndex === 0) {
            return "Oran: %" + ((parseInt(value) / parseInt(w.config.series[1].data[dataPointIndex])) * 100).toFixed(1);
          }
        },
      },
      stroke: {
        width: [0, 4]
      },
      xaxis: {
        categories: data.map((item) => [`01 Ocak ${item.Year}`, '-', `${item.Date}`]),
      },
      yaxis: [
        {
          title: {
            text: 'Şikayetler'
          }
        },
        {
          opposite: true,
          title: {
            text: 'Mamul Adedi'
          }
        }
      ],
      tooltip: {
        shared: true,
        intersect: false
      },
      markers: {
        size: 5
      }
    }
  };

  const lastYearComplaintRate = ServiceComplaintData.series[0].data[0] / ServiceComplaintData.series[1].data[0];
  const thisYearComplaintRate = ServiceComplaintData.series[0].data[1] / ServiceComplaintData.series[1].data[1];
  const serviceComplaintIncrease = ((thisYearComplaintRate - lastYearComplaintRate) / lastYearComplaintRate * 100).toFixed(1);

  const isPositive = serviceComplaintIncrease >= 0;
  const chartTitle = isPositive ? 'Artış Oranı' : 'Azalış Oranı';
  const chartColor = isPositive ? '#d32f2f' : '#2e7d32';

  const ServiceComplaintPercentageData = {
    series: [Math.abs(serviceComplaintIncrease)],
    chart: {
      height: 350,
      type: 'radialBar',
      offsetY: -10
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: '16px',
            color: chartColor,
            offsetY: 70
          },
          value: {
            offsetY: 80,
            fontSize: '22px',
            formatter: function (val) {
              return val + "%";
            }
          }
        }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91]
      },
    },
    stroke: {
      dashArray: 4
    },
    //labels isPositive ? ['Artış Oranı'] : ['Azalış Oranı'],
    labels: [chartTitle],
    colors: [chartColor],
  };

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={8}>
          {loading ? (
            <Skeleton variant="rectangular" height={350} width={'100%'} />
          ) : (
            <Chart
              options={ServiceComplaintData.options}
              series={ServiceComplaintData.series}
              type="line"
              height={350}
            />
          )}
        </Grid>
        <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {loading ? (
            <Skeleton variant="rectangular" height={280} width={'100%'} />
          ) : (
            <Chart
              options={ServiceComplaintPercentageData}
              series={ServiceComplaintPercentageData.series}
              type="radialBar"
              height={280}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          {loading ? (
            <Skeleton variant="rectangular" height={100} />
          ) : (
            (EmployeeRole === 1 || EmployeeRole === 2) && (
              <Alert
                variant="outlined"
                severity="info"
                sx={{
                  borderColor: theme.palette.info.dark,
                  fontSize: '12px',
                  fontFamily: 'Helvetica, Arial, sans-serif'
                }}>
                Detaylı kırılımlarda görüntülemek için Atlas dashboardlardan faydalanabilirsiniz.
                <br />
                <Link
                  href="https://atlas.beko.com/okta/sense/app/48e84271-abbf-4c9e-8241-2782a507dbec/sheet/eb9a1342-9acc-4e3f-ae66-a258615a7126/state/analysis"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  İlgili Atlas dashboardundan faydalanmak için tıklayınız.
                </Link>
              </Alert>
            )
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ServiceComplaint;
